module.exports = __webpack_public_path__ + "static/media/lock-alt.869638a8.svg";